import React, { useState, useEffect } from 'react'
import { Image, Form, Button } from 'react-bootstrap'
import logo from '../../assets/FAEX_Logo.png'
import { FetchLogin, FetchReadServerVersion } from '../../fetcher'

/**
 * View to display the login page
 * @param {any} handleSubmit handles submit when logindata are entered
 * @param {string} username the users name
 * @param {string} password the users password
 * @param {any} setUsername hook to set username
 * @param {any} setPassword hook to set password
 * @param {any} validateForm handles form validation to determine if login button should be enabled
 * @param {boolean} error indicated whether error message should be displayed
 */
const LoginView = ({ handleSubmit, username, password, setUsername, setPassword, validateForm, error }) => {
    const [serverVersion, setServerVersion] = useState("");

    useEffect(() => {
        FetchReadServerVersion(setServerVersion)
    }, [])

    return (
        <div className="login login-margin text-center">
            <Image src={logo} rounded />
            <div className="server-environment">{serverVersion}</div>
            <div className="login">
                <Form onSubmit={handleSubmit}>
                    <Form.Group size="lg" controlId="username">
                        <Form.Control className="text-center"
                            autoFocus
                            value={username}
                            placeHolder="NAME"
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group size="lg" controlId="password">
                        <Form.Control className="text-center"
                            type="password"
                            value={password}
                            placeHolder={window.i18n('password')}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </Form.Group>
                    <Button variant="secondary" block size="lg" type="submit" disabled={!validateForm()}> Login </Button>

                    {error ?
                        <div className="error">Username oder Passwort sind falsch. Bitte probieren Sie es erneut.</div>
                        : null}
                </Form>
            </div>
        </div>
    )
}

export { LoginView }